// App.js
import React from 'react';
import './App.scss'; // Import the SCSS file for styling

// Header Component with Navigation
const Header = () => {
  return (
    <header className="header">
      <div className="logo">
        {/* The header shows the logo image */}
        <img src="/images/logo.png" alt="Reese Painting Logo" />
      </div>
      <nav>
        <ul>
          <li><a href="#hero">Home</a></li>
          <li><a href="#about">About</a></li>
          <li><a href="#services">Services</a></li>
          <li><a href="#gallery">Gallery</a></li>
          <li><a href="#contact">Contact</a></li>
        </ul>
      </nav>
    </header>
  );
};

// Hero Section with the logo replacing the text title
const Hero = () => {
  return (
    <section id="hero" className="hero">
      {/* Display the logo image in a fixed, medium size */}
      <img src="/images/logo.png" alt="Reese Painting Logo" className="hero-logo" />
      <p>Quality Residential Painting by a Dedicated Father–Son Team</p>
    </section>
  );
};

// About Section with details about the father–son team, regional focus, and services
const About = () => {
  return (
    <section id="about" className="about section-card">
      <h2>About Reese Painting</h2>
      <p>
        Reese Painting is a dedicated father–son team specializing in residential painting. With over 40 years of combined experience,
        we bring passion, precision, and quality to every project. Our focus is on transforming your home with beautiful, long-lasting finishes
        that enhance your living space.
      </p>
      <p>
        Based in Bandon, we proudly serve the Coos County area.
      </p>
      <p>
        We work closely with our clients to understand their vision and deliver exceptional results—from interior and exterior painting to pressure washing,
        drywall repairs, and wallpaper removal.
      </p>
    </section>
  );
};

// Services Section using rounded cards with shadows and hover effects
const Services = () => {
  const servicesData = [
    "Interior Painting",
    "Exterior Painting",
    "Pressure Washing",
    "Drywall Repairs",
    "Wallpaper Removal",
  ];

  return (
    <section id="services" className="services">
      <h2>Our Services</h2>
      <div className="services-cards">
        {servicesData.map((service, index) => (
          <div key={index} className="service-card">
            <h3>{service}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

// Gallery Section using a slider that automatically loads images from a folder
const Gallery = () => {
  // Use Webpack's require.context to dynamically load all images from src/assets/gallery
  const importAll = (r) => r.keys().map(r);
  const images = importAll(
    require.context('./assets/gallery', false, /\.(png|jpe?g|svg)$/)
  );
  const [currentIndex, setCurrentIndex] = React.useState(0);
  const totalImages = images.length;

  // Auto-advance the slider every 3 seconds
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
    }, 3000);
    return () => clearInterval(interval);
  }, [totalImages]);

  const goPrev = () => {
    setCurrentIndex((currentIndex - 1 + totalImages) % totalImages);
  };

  const goNext = () => {
    setCurrentIndex((currentIndex + 1) % totalImages);
  };

  return (
    <section id="gallery" className="gallery">
      <h2>Gallery</h2>
      <div className="gallery-slider">
        <button onClick={goPrev} className="slider-btn prev-btn">&#10094;</button>
        {totalImages > 0 && (
          <img
            src={images[currentIndex]}
            alt={`Gallery Slide ${currentIndex + 1}`}
            className="slider-image"
          />
        )}
        <button onClick={goNext} className="slider-btn next-btn">&#10095;</button>
      </div>
      <div className="slider-dots">
        {images.map((_, idx) => (
          <span
            key={idx}
            className={`dot ${idx === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(idx)}
          ></span>
        ))}
      </div>
    </section>
  );
};

// Contact Section with updated phone numbers and email; address removed.
const Contact = () => {
  return (
    <section id="contact" className="contact section-card">
      <h2>Contact Us</h2>
      <p>
        Call us: <a href="tel:+19252167066">(925) 216-7066</a> or{' '}
        <a href="tel:+19258585863">(925) 858-5863</a>
      </p>
      <p>
        Email: <a href="mailto:reesepainting@outlook.com">reesepainting@outlook.com</a>
      </p>
    </section>
  );
};

// LicenseCards Component that displays two separate cards
const LicenseCards = () => {
  return (
    <div className="license-cards-container">
      <div className="license-card">
        Licensed, Bonded, and Insured
      </div>
      <div className="license-card license-number-card">
        CCB:
241858
      </div>
    </div>
  );
};

// Footer Section
const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Reese Painting. All Rights Reserved.</p>
    </footer>
  );
};

// Main App Component
const App = () => {
  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Contact />
      <LicenseCards />
      <Footer />
    </div>
  );
};

export default App;
